import {ReactComponent as SuspiciousIcon} from "../../../core/ui/icon/Suspicious.svg";

import "./_swap-form-error-view.scss";

import Typography from "../../../component/typography/Typography";

interface SwapFormErrorViewProps {
  error: Error;
}

function SwapFormErrorView({error}: SwapFormErrorViewProps) {
  return (
    <div className={"swap-form-error-view is-centered is-flex-column"}>
      <SuspiciousIcon width={32} height={32} className={"swap-form-error-view__icon"} />

      <Typography textColor={"helper-danger"}>{error.message}</Typography>
    </div>
  );
}

export default SwapFormErrorView;
